import React from 'react'
import PropTypes from 'prop-types'
import ImageCarousel from 'components/ImageCarousel'

import { Cancel, CheckCircle } from '@mui/icons-material'
import Colors from 'utils/Colors'

import moment from 'moment'
import { maskString } from 'utils/functions'

import styles from './styles'

function ProspectDetails(props) {
  const { info } = props

  const classes = styles()

  const buildDocumentData = (optimizedImageName, description, alt, originalImageName) => {
    return {
      optimizedImageName: optimizedImageName,
      description: description,
      alt: alt,
      originalImageName: originalImageName,
    }
  }

  const buildImagesArray = () => {
    const isFrontAndBackEqual = info?.document?.front.optimized === info?.document?.back.optimized
    const photos = []
    if (info.selfie.optimized) {
      photos.push(buildDocumentData(info.selfie.optimized, 'Selfie', 'Foto do candidato', info.selfie.original))
    }
    if (info.document.front.optimized) {
      photos.push(
        buildDocumentData(
          info.document.front.optimized,
          isFrontAndBackEqual ? 'Documento' : 'Frente do documento',
          isFrontAndBackEqual
            ? 'Documento de identificação'
            : 'Frente do documento de identificação',
          info.document.front.original,
        ),
      )
    }
    if (!isFrontAndBackEqual) {
      photos.push(
        buildDocumentData(
          info.document.back.optimized,
          'Verso do documento',
          'Verso do documento de identificação',
          info.document.back.original,
        ),
      )
    }
    return photos
  }

  const getDataMatch = (matchInfo) => {
    if (matchInfo === undefined || matchInfo === null) return null
    return matchInfo ? (
      <CheckCircle style={{ color: Colors.green }} />
    ) : (
      <Cancel style={{ color: Colors.red }} />
    )
  }

  return (
    <div className={classes.root}>
      <ImageCarousel items={buildImagesArray()} />
      <div className={classes.candidateDetails}>
        <h2>{info.name}</h2>
        <h3>Informações extraídas</h3>
        <div className={classes.items}>
          <div className={classes.item}>
            <span className={classes.label}>CPF:</span>
            <span>{maskString(info?.person_info?.cpf, 'cpf')}</span>
            {getDataMatch(info?.match_info?.cpf)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Documento:</span>
            <span>{info?.person_info?.document_number}</span>
            {getDataMatch(info?.match_info?.document_number)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Nome:</span>
            <span>{info?.person_info?.name}</span>
            {getDataMatch(info?.match_info?.name)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Nome da mãe:</span>
            <span>{info?.person_info?.mother_name}</span>
            {getDataMatch(info?.match_info?.mother_name)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Nome do pai:</span>
            <span>{info?.person_info?.father_name}</span>
            {getDataMatch(info?.match_info?.father_name)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Data de nascimento:</span>
            <span>
              {info?.person_info?.birth_date && moment(info?.person_info?.birth_date).format('DD/MM/YYYY')}
            </span>
            {getDataMatch(info?.match_info?.birth_date)}
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Telefones:</span>
            <ul style={{ marginLeft: 0 }}>
              {info?.person_info?.phones?.map(phone => (
                <li key={[phone.phone, phone.network, phone.whatsapp].join('')}>
                  <span>{phone.phone}</span>
                  {phone.network && <span>&nbsp; ({phone.network})</span>}
                  {phone.whatsapp && <span>&nbsp; (Whatsapp)</span>}
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Emails:</span>
            <ul>
              {info?.person_info?.emails?.map(email => (
                <li key={email} style={{ marginLeft: 0 }}>
                  <span>{email}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.item}>
            <span className={classes.label}>Idade:</span>
            <span>{info?.person_info?.age}</span>
            {getDataMatch(info?.match_info?.age)}
          </div>
        </div>
      </div>
    </div>
  )
}

ProspectDetails.propTypes = {
  info: PropTypes.object,
}

ProspectDetails.defaultProps = {
  info: null,
}

export default ProspectDetails
